import React from 'react';
import Add from '@material-ui/icons/Add';
import AttachFile from '@material-ui/icons/AttachFile';
import Clear from '@material-ui/icons/Clear';
import DateRange from '@material-ui/icons/DateRange';
import DirectionsRun from '@material-ui/icons/DirectionsRun';
import DoneOutline from '@material-ui/icons/DoneOutline';
import Email from '@material-ui/icons/Email';
import Event from '@material-ui/icons/Event';
import EventAvailable from '@material-ui/icons/EventAvailable';
import EventNote from '@material-ui/icons/EventNote';
import IndeterminateCheckBox from '@material-ui/icons/IndeterminateCheckBox';
import LocalPhone from '@material-ui/icons/LocalPhone';
import PermIdentity from '@material-ui/icons/PermIdentity';
import PersonOutline from '@material-ui/icons/PersonOutline';
import Phone from '@material-ui/icons/Phone';
import Remove from '@material-ui/icons/Remove';
import ReportProblem from '@material-ui/icons/ReportProblem';
import RssFeed from '@material-ui/icons/RssFeed';
import Work from '@material-ui/icons/Work';
import MergeType from '@material-ui/icons/MergeType';
import Unarchive from '@material-ui/icons/Unarchive';
import Contacts from '@material-ui/icons/Contacts';
import ContactMail from '@material-ui/icons/ContactMail';
import { SvgIconProps } from '@material-ui/core';

const iconMap: Record<string, React.ElementType<SvgIconProps>> = {
	add: Add,
	attach_file: AttachFile,
	clear: Clear,
	date_range: DateRange,
	directions_run: DirectionsRun,
	done_outline: DoneOutline,
	email: Email,
	event: Event,
	event_available: EventAvailable,
	event_note: EventNote,
	indeterminate_check_box: IndeterminateCheckBox,
	local_phone: LocalPhone,
	perm_identity: PermIdentity,
	person_outline: PersonOutline,
	phone: Phone,
	remove: Remove,
	report_problem: ReportProblem,
	rss_feed: RssFeed,
	work: Work,
    merge_type: MergeType,
    unarchive: Unarchive,
    contacts: Contacts,
    contact_mail: ContactMail
};

export const getIconComponent = (name: string): JSX.Element => {
	const Component = iconMap[name];
	return Component ? <Component /> : <span>{name}</span>;
};
